// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"a006a520","520":"0540f059"}[chunkId] + ".chunk.js";
};